<template >
<el-dialog
  title="各地区扶贫人口分布"
  :visible.sync="dialog"
  width="1200px"
  :modal-append-to-body='true'
  :append-to-body='true'
   :class='dialog'>
   <slot name="content">

 <div class="bg" v-if="data.length"> 
   
    <img src="../../../assets/imgs/sgz.png"
         alt="" class="mapImg">
     <div class="hexi asb"
         v-if='city.hexi'
         :style='`width:${city.hexi.size*$store.state.ratio.width}px;height:${city.hexi.size*$store.state.ratio.width}px;top:${300}px;left:${300}px`'
         @mouseenter="enter(0)"
         @mouseleave="leave(0)">
      <div class="mapTips"
           :style='`min-width:${100*$store.state.ratio.width}px;top:${-30*$store.state.ratio.height}px;left:${20*$store.state.ratio.width}px`'>
        <p class="p1">河西镇</p>
        <div class="p2">扶贫人口:{{city.hexi.value}}</div>
      </div>
    </div>
    <div class="dingtang asb"
         @mouseenter="enter(1)"
         @mouseleave="leave(1)"
         v-if="city.dingtang"
         :style='`width:${city.dingtang.size*$store.state.ratio.width}px;height:${city.dingtang.size*$store.state.ratio.width}px;top:${440}px;left:${280}px`'>
      <div class="mapTips"
           :style='`min-width:${100*$store.state.ratio.width}px;top:${-30*$store.state.ratio.height}px;left:${20*$store.state.ratio.width}px`'>
        <p class="p1">丁塘镇</p>
        <div class="p2">扶贫人口:{{city.dingtang.value}}</div>
      </div>
    </div>  
    <div class="yuhai asb"
         @mouseenter="enter(2)"
         @mouseleave="leave(2)"
         v-if="city.yuhai"
         :style='`width:${city.yuhai.size*$store.state.ratio.width}px;height:${city.yuhai.size*$store.state.ratio.width}px;top:${505}px;left:${311}px`'>
      <div class="mapTips"
           :style='`min-width:${100*$store.state.ratio.width}px;top:${-30*$store.state.ratio.height}px;left:${20*$store.state.ratio.width}px`'>
        <p class="p1">豫海镇</p>
        <div class="p2">扶贫人口:{{city.yuhai.value}}</div>
      </div>
    </div>
    <div class="xinglong asb"
         @mouseenter="enter(3)"
         @mouseleave="leave(3)"
         v-if="city.xinglong"
         :style='`width:${city.xinglong.size*$store.state.ratio.width}px;height:${city.xinglong.size*$store.state.ratio.width}px;top:${606}px;left:${250}px`'>
      <div class="mapTips"
           :style='`min-width:${100*$store.state.ratio.width}px;top:${-30*$store.state.ratio.height}px;left:${20*$store.state.ratio.width}px`'>
        <p class="p1">兴隆乡</p>
        <div class="p2">扶贫人口:{{city.xinglong.value}}</div>
      </div>
    </div>
    <div class="shishi asb"
         @mouseenter="enter(4)"
         @mouseleave="leave(4)"
         v-if="city.shishi"
         :style='`width:${city.shishi.size*$store.state.ratio.width}px;height:${city.shishi.size*$store.state.ratio.width}px;top:${521}px;left:${385}px`'>
      <div class="mapTips"
           :style='`min-width:${100*$store.state.ratio.width}px;top:${-30*$store.state.ratio.height}px;left:${20*$store.state.ratio.width}px`'>
        <p class="p1">石狮镇</p>
        <div class="p2">扶贫人口:{{city.shishi.value}}</div>
      </div>
    </div>
    <div class="jiaoshan asb"
         @mouseenter="enter(5)"
         @mouseleave="leave(5)"
         v-if="city.jiaoshan"
         :style='`width:${city.jiaoshan.size*$store.state.ratio.width}px;height:${city.jiaoshan.size*$store.state.ratio.width}px;top:${480}px;left:${519}px`'>
      <div class="mapTips"
           :style='`min-width:${100*$store.state.ratio.width}px;top:${-30*$store.state.ratio.height}px;left:${20*$store.state.ratio.width}px`'>
        <p class="p1">窑山管委会</p>
        <div class="p2">扶贫人口:{{city.jiaoshan.value}}</div>
      </div>
    </div>
    <div class="wangtuan asb"
         @mouseenter="enter(6)"
         @mouseleave="leave(6)"
         v-if="city.wangtuan"
         :style='`width:${city.wangtuan.size*$store.state.ratio.width}px;height:${city.wangtuan.size*$store.state.ratio.width}px;top:${664}px;left:${477}px`'>
      <div class="mapTips"
           :style='`min-width:${100*$store.state.ratio.width}px;top:${-30*$store.state.ratio.height}px;left:${20*$store.state.ratio.width}px`'>
        <p class="p1">王团镇</p>
        <div class="p2">扶贫人口:{{city.wangtuan.value}}</div>
      </div>
    </div>
    <div class="yuwang asb"
         @mouseenter="enter(7)"
         @mouseleave="leave(7)"
         v-if="city.yuwang"
         :style='`width:${city.yuwang.size*$store.state.ratio.width}px;height:${city.yuwang.size*$store.state.ratio.width}px;top:${658}px;left:${661}px`'>
      <div class="mapTips"
           :style='`min-width:${100*$store.state.ratio.width}px;top:${-30*$store.state.ratio.height}px;left:${20*$store.state.ratio.width}px`'>
        <p class="p1">预旺镇</p>
        <div class="p2">扶贫人口:{{city.yuwang.value}}</div>
      </div>
    </div>
    <div class="tianlao asb"
         @mouseenter="enter(8)"
         @mouseleave="leave(8)"
         v-if="city.tianlao"
         :style='`width:${city.tianlao.size*$store.state.ratio.width}px;height:${city.tianlao.size*$store.state.ratio.width}px;top:${390}px;left:${680}px`'>
      <div class="mapTips"
           :style='`min-width:${100*$store.state.ratio.width}px;top:${-30*$store.state.ratio.height}px;left:${20*$store.state.ratio.width}px`'>
        <p class="p1">田老庄乡</p>
        <div class="p2">扶贫人口:{{city.tianlao.value}}</div>
      </div>
    </div>
    <div class="zhangjia asb"
         @mouseenter="enter(9)"
         @mouseleave="leave(9)"
         v-if="city.zhangjia"
         :style='`width:${city.zhangjia.size*$store.state.ratio.width}px;height:${city.zhangjia.size*$store.state.ratio.width}px;top:${861}px;left:${707}px`'>
      <div class="mapTips"
           :style='`min-width:${100*$store.state.ratio.width}px;top:${-30*$store.state.ratio.height}px;left:${20*$store.state.ratio.width}px`'>
        <p class="p1">张家塬乡</p>
        <div class="p2">扶贫人口:{{city.zhangjia.value}}</div>
      </div>
    </div>
    <div class="magao asb"
         @mouseenter="enter(10)"
         @mouseleave="leave(10)"
         v-if="city.magao"
         :style='`width:${city.magao.size*$store.state.ratio.width}px;height:${city.magao.size*$store.state.ratio.width}px;top:${618}px;left:${850}px`'>
      <div class="mapTips"
           :style='`min-width:${100*$store.state.ratio.width}px;top:${-30*$store.state.ratio.height}px;left:${20*$store.state.ratio.width}px`'>
        <p class="p1">马高庄乡</p>
        <div class="p2">扶贫人口:{{city.magao.value}}</div>
      </div>
    </div>
    <div class="xiama asb"
         @mouseenter="enter(11)"
         @mouseleave="leave(11)"
         v-if="city.xiama"
         :style='`width:${city.xiama.size*$store.state.ratio.width}px;height:${city.xiama.size*$store.state.ratio.width}px;top:${350}px;left:${850}px`'>
      <div class="mapTips"
           :style='`min-width:${100*$store.state.ratio.width}px;top:${-30*$store.state.ratio.height}px;left:${20*$store.state.ratio.width}px`'>
        <p class="p1">下马关镇</p>
        <div class="p2">扶贫人口:{{city.xiama.value}}</div>
      </div>
    </div>
    <div class="weizhou asb"
         @mouseenter="enter(12)"
         @mouseleave="leave(12)"
         v-if="city.weizhou"
         :style='`width:${city.weizhou.size*$store.state.ratio.width}px;height:${city.weizhou.size*$store.state.ratio.width}px;top:${123}px;left:${850}px`'>
      <div class="mapTips"
           :style='`min-width:${100*$store.state.ratio.width}px;top:${-30*$store.state.ratio.height}px;left:${20*$store.state.ratio.width}px`'>
        <p class="p1">韦州镇</p>
        <div class="p2">扶贫人口:{{city.weizhou.value}}</div>
      </div>
    </div>
    <!-- <div class="tongxin asb"
         @mouseenter="enter(13)"
         @mouseleave="leave(13)"
         v-if="city.tongxin"
         :style='`width:${city.tongxin.size*$store.state.ratio.width}px;height:${city.tongxin.size*$store.state.ratio.width}px;top:${307}px;left:${410}px`'>
      <div class="mapTips"
           :style='`min-width:${100*$store.state.ratio.width}px;top:${-30*$store.state.ratio.height}px;left:${20*$store.state.ratio.width}px`'>
        <p class="p1">同心县</p>
        <div class="p2">扶贫人口:{{city.tongxin.value}}</div>
      </div>
    </div>   -->
  </div> 
   </slot>
</el-dialog>
</template>
<script>
export default {
  props: ['data'],
  data () {
    return {
        dialog: false,
      city: {
        hexi: { value: 0, name: '河西镇', size: 10, index: 0 },
        dingtang: { value: 0, name: '丁塘镇', size: 10, index: 1 },
        yuhai: { value: 0, name: '豫海镇', size: 10, index: 2},
        xinglong: { value: 0, name: '兴隆乡', size: 10, index: 3 },
        shishi: { value: 0, name: '石狮镇', size: 10, index: 4 },
        jiaoshan: { value: 0, name: '窑山管委会', size: 10, index: 5 },
        wangtuan: { value: 0, name: '王团镇', size: 10, index:6 },
        yuwang: { value: 0, name: '预旺镇', size: 10, index:7 },
        tianlao: { value: 0, name: '田老庄乡', size: 10, index: 8 },
        zhangjia: { value: 0, name: '张家塬乡', size: 10, index: 9 },
        magao: { value: 0, name: '马高庄乡', size: 10, index: 10 },
        xiama: { value: 0, name: '下马关镇', size: 10, index: 11 },
        weizhou: { value: 0, name: '韦州镇', size: 10, index: 12},
        // tongxin: { value: 0, name: '同心县', size: 10, index: 13}
      }
    }
  },
  watch: {

    data: {
      handler: function () {
        this.handleData()
      },
      deep: true    },
  },
  created () {
    this.handleData()
  },
  methods: {
    init(){
     this.dialog=true
     this.handleData()
     console.log(this.city,'city');
    },
    handleData () {
      let max = this.data[0].value
      let min = this.data[this.data.length - 1].value
      let interval = (max - min) / 8
      this.data.forEach(item => {
        let n = 0
        for (let j = 0; j < 8; j++) {
          if (j * interval > item.value) {
          } else {
            n++
          }
        }

        for (var i in this.city) {
          if (item.name == this.city[i].name) {
            this.city[i].value = item.value
            this.city[i].size = 2 * (4 + n)
          }
        }
      })
    },
    enter (index) {
      let tipsArr = document.querySelectorAll(".mapTips")
      tipsArr[index].style.display = 'block'
      
      for (let i in this.city) {
        if (this.city[i].index == index) {
          this.city[i].size = this.city[i].size + 4
        }
      }
    }, leave (index) {
      let tipsArr = document.querySelectorAll(".mapTips")
      tipsArr[index].style.display = 'none'
      for (let i in this.city) {
        if (this.city[i].index == index) {
          this.city[i].size = this.city[i].size - 4
        }
      }
    }
  },
}
</script>
<style lang="scss" scoped>
/deep/ .el-dialog__body{
      background:#0d1b35;
      position: relative;
        .asb {
    position: absolute;
    background: red;
    border-radius: 50%;
    box-shadow: 0 0 10px black;
    cursor: pointer;
    .mapTips {
      position: absolute;
      background: white;
      border-radius: 10%;
      color: black;
      display: none;
      .p1 {
        text-align: center;
      }
      .p2 {
        text-align: center;
        white-space: nowrap;
      }
    }
  }
}
/deep/ .el-dialog__header{
      background:#0d1b35;
}
/deep/ .el-dialog__title{
      color: yellow;
}
/deep/ .el-icon-close:before{
      color: #ffff;
}

.bg {
  background:#0d1b35;
    position: relative;

    .mapImg {
    margin-top: 10px;
    width: 100%;
    height: 85%;
    background-color: #0d1b35;
    
  }
  .title {
    background: #0d1b35;
    color: yellow;
    position: absolute;
  }

}
</style>